import { render, staticRenderFns } from "./customer-support-action.vue?vue&type=template&id=c478bd10&"
import script from "./customer-support-action.vue?vue&type=script&lang=js&"
export * from "./customer-support-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports